import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SideViewComponent } from './components/side-view/side-view.component';
import { MapViewComponent } from './components/map-view/map-view.component';
import { DutyViewComponent } from './components/duty-view/duty-view.component'
import { LoaderModule } from 'mis-crystal-design-system/loader';
import { DriverCardComponent } from './components/cards/driver-card/driver-card.component';
import { AttendanceCardComponent } from './components/cards/attendance-card/attendance-card.component'
import { DatepickerModuleV2 } from "mis-crystal-design-system/datepicker_v2";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    SideViewComponent,
    MapViewComponent,
    DutyViewComponent,
    DriverCardComponent,
    AttendanceCardComponent
  ],
  imports: [
    LoaderModule,
    DatepickerModuleV2,
    FormsModule,
    ReactiveFormsModule,
  ]
})
export class DutyViewModule 
{

}